import { IPathToPageIdMap } from '@move-frontend/contentful-routes';
import {
	EXTERNAL_LINK_TYPE_ID,
	IExternalLinkEntry,
	IInternalLinkEntry,
} from '../contentful';

export type MaybeLink = IInternalLinkEntry | IExternalLinkEntry | undefined;

export function getUrlForPageId(
	pageId: string,
	pathToPageIdMap: IPathToPageIdMap,
) {
	const matchedPage = Object.entries(pathToPageIdMap).find(
		([, id]) => id === pageId,
	);

	if (!matchedPage) return `/${pageId}`;

	const [path] = matchedPage;

	return path;
}

export function getUrlForLink(
	link: MaybeLink,
	pathToPageIdMap: IPathToPageIdMap,
) {
	if (!link) return undefined;

	if (link.contentType === EXTERNAL_LINK_TYPE_ID) {
		return link.fields.url;
	}

	return getUrlForInternalLink(link, pathToPageIdMap);
}

export function getUrlForInternalLink(
	link: IInternalLinkEntry,
	pathToPageIdMap: IPathToPageIdMap,
) {
	let url = link.fields.page
		? getUrlForPageId(link.fields.page.fields.id, pathToPageIdMap)
		: '';

	if (link.fields.hash) {
		url += `#${link.fields.hash}`;
	}

	return url;
}
